import React from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import LayersRoundedIcon from '@mui/icons-material/LayersRounded';

// De onde veio a nota usada na formação dos times (services/rankingTimesService na API)
const ORIGENS = {
  avaliacao: { icone: <StarRoundedIcon />, nome: 'Avaliações da pelada' },
  torneio: { icone: <EmojiEventsRoundedIcon />, nome: 'Ranking do torneio' },
  pote: { icone: <LayersRoundedIcon />, nome: 'Pote informado' },
};

/** Nota de 0 a 100 do jogador na formação dos times; o toque/hover mostra a origem (`info` = { nota, origem, detalhe }). */
const NotaJogador = ({ info }) => {
  if (!info || info.nota === null || info.nota === undefined) return null;
  const origem = ORIGENS[info.origem] || {};
  return (
    <Tooltip title={`${origem.nome || 'Nota'}: ${info.detalhe || ''}`} enterTouchDelay={0}>
      <Chip
        size="small"
        variant="outlined"
        icon={origem.icone}
        label={info.nota}
        aria-label={`Nota ${info.nota}. ${origem.nome || ''} ${info.detalhe || ''}`}
        sx={{ flexShrink: 0, fontWeight: 700, '& .MuiChip-icon': { fontSize: 16 } }}
      />
    </Tooltip>
  );
};

/** Média das notas de um time (null se ninguém tem nota). */
export const mediaDoTime = (time = [], notas = {}) => {
  const valores = time.map((j) => notas[j.user_name]?.nota).filter((n) => n !== null && n !== undefined);
  return valores.length ? Math.round(valores.reduce((s, n) => s + n, 0) / valores.length) : null;
};

export default NotaJogador;
